import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ContextMenuDialogComponent } from '../../components/dialog/context-menu/context-menu-dialog.component';

@Directive({
  selector: '[appEditableContent]'
})
export class EditableContentDirective {
  @Input('appEditableText') contentKey!: string;

  constructor(private el: ElementRef, private dialog: MatDialog) {}

  @HostListener('contextmenu', ['$event'])
  onRightClick(event: MouseEvent) {
    event.preventDefault();
    console.log(event);

    // Optionally highlight the element
    this.el.nativeElement.classList.add('editable-highlight');

    const dialogRef = this.dialog.open(ContextMenuDialogComponent, {
      data: {
        key: this.contentKey,
        currentText: this.el.nativeElement.innerText,
        targetElement: this.el.nativeElement
      },
      position: {
        top: `${event.clientY}px`,
        left: `${event.clientX}px`
      },
      panelClass: 'context-menu-panel',
      backdropClass: 'context-menu-backdrop'
    });
    dialogRef.afterClosed().subscribe(() => {
      // Remove highlight after menu closes
      this.el.nativeElement.classList.remove('editable-highlight');
    });
  }
}
